import classes from "./ModalWrapper.module.css";
import useEnterKey from "../../helperFunctions/customHooks/useEnterKeySubmit";
import { useState } from "react";
import { ModalHeader } from "../modalHeader/ModalHeader";
import { useSelector } from "react-redux";
import { useEscapeKeyClose } from "../../helperFunctions/customHooks/useEscapeKeyClose";

export default function ModalWrapper({
  children,
  width = "600px",
  style = {},
  title,
  onClick,
  onSubmit = null,
  resetButton,
  bgColor,
  closeButton,
  headerWidth,
  ...props
}) {
  const [isClosing, setIsClosing] = useState(false);

  const { isModalsBgShown } = useSelector((state) => state.global);

  function handleClose() {
    if (isClosing) return;
    setIsClosing(true);
    setTimeout(() => {
      onClick();
    }, 300);
  }

  useEscapeKeyClose(handleClose);
  useEnterKey(onSubmit);

  if (!isModalsBgShown) return null;

  return (
    <div
      className={`${classes.modalBackground} ${
        isClosing ? classes.fadeOut : classes.fadeIn
      }`}
      onClick={handleClose}
    >
      <div
        className={`${classes.modalWrapper} ${
          isClosing ? classes.fadeOutModal : classes.fadeInModal
        }`}
        style={{
          width,
          ...style,
          backgroundColor: bgColor ? bgColor : "white",
        }}
        onClick={(e) => e.stopPropagation()}
        {...props}
      >
        <ModalHeader
          onClick={handleClose}
          title={title}
          resetButton={resetButton}
          closeButton={closeButton}
          headerWidth={headerWidth}
        />
        {children}
      </div>
    </div>
  );
}
